(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orela-gummy-routine"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('orela-gummy-routine')) {
    customElements.define('orela-gummy-routine', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.controller = new AbortController();
        this.setAttribute('data-ready', '');
        const options = { signal: this.controller.signal };
        const timeline = this.querySelector('.orela-gummy-routine__timeline');
        const motion = this.querySelector('[data-motion-toggle]');
        if (motion) {
          motion.hidden = false;
          motion.addEventListener('click', () => {
            const paused = this.toggleAttribute('data-paused');
            motion.setAttribute('aria-label', paused ? motion.dataset.playLabel : motion.dataset.pauseLabel);
          }, options);
        }
        if (!timeline) return;
        const update = () => {
          const total = timeline.scrollWidth;
          const thumb = total ? Math.min(100, timeline.clientWidth / total * 100) : 100;
          const progress = total ? Math.max(0, Math.min(100 - thumb, timeline.scrollLeft / total * 100)) : 0;
          this.style.setProperty('--routine-thumb', `${thumb}%`);
          this.style.setProperty('--routine-progress', `${progress}%`);
        };
        timeline.addEventListener('scroll', update, { ...options, passive: true });
        timeline.addEventListener('keydown', (event) => {
          if (event.target !== timeline || !['ArrowLeft', 'ArrowRight'].includes(event.key) || timeline.scrollWidth <= timeline.clientWidth) return;
          event.preventDefault();
          timeline.scrollBy({ left: (event.key === 'ArrowRight' ? 1 : -1) * timeline.clientWidth * .8, behavior: 'auto' });
        }, options);
        document.addEventListener('shopify:block:select', (event) => {
          const step = event.target.closest('.orela-gummy-routine__step');
          if (step && this.contains(step)) step.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'auto' });
        }, options);
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(timeline);
        update();
      }
      disconnectedCallback() { this.controller?.abort(); this.resizeObserver?.disconnect(); this.removeAttribute('data-ready'); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orela-home-product-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('orela-home-product-slider')) {
    customElements.define('orela-home-product-slider', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (this.slides.length < 2) return;
        this.abort = new AbortController();
        const listen = (target, type, handler, options = {}) => target.addEventListener(type, handler, { ...options, signal: this.abort.signal });
        this.index = 0;
        this.interval = Number(this.dataset.interval) || 7000;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches || Boolean(window.Shopify?.designMode);
        this.inView = false;
        this.hovered = false;
        this.dots = Array.from(this.querySelectorAll('[data-go-to]'));
        this.rotation = this.querySelector('[data-rotation]');
        this.status = this.querySelector('[data-live-status]');
        this.querySelector('[data-controls]').hidden = false;
        listen(this, 'click', event => {
          if (Date.now() < (this.suppressClickUntil || 0) && event.target.closest('a')) { event.preventDefault(); return; }
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-rotation')) { this.paused = !this.paused; this.sync(); }
          else if (button.hasAttribute('data-go-to')) this.show(Number(button.dataset.goTo), event.detail === 0);
        });
        listen(this, 'keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        });
        listen(this, 'focusin', event => {
          if (event.target === this.rotation || !event.target.matches(':focus-visible')) return;
          this.paused = true;
          this.sync();
        });
        listen(this, 'pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.sync(); } });
        listen(this, 'pointerleave', () => { this.hovered = false; this.sync(); });
        listen(this, 'touchstart', event => {
          this.touching = true;
          this.touch = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
          this.sync();
        }, { passive: true });
        listen(this, 'touchend', event => {
          this.touching = false;
          if (!this.touch || !event.changedTouches.length) { this.sync(); return; }
          const dx = event.changedTouches[0].clientX - this.touch.x;
          const dy = event.changedTouches[0].clientY - this.touch.y;
          this.touch = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
            this.suppressClickUntil = Date.now() + 400;
            this.show(this.index + (dx < 0 ? 1 : -1));
          } else this.sync();
        }, { passive: true });
        listen(this, 'touchcancel', () => { this.touch = null; this.touching = false; this.sync(); }, { passive: true });
        listen(document, 'visibilitychange', () => this.sync());
        listen(this.motion, 'change', () => { if (this.motion.matches) this.paused = true; this.sync(); });
        listen(document, 'shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.show(index, true);
        });
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.sync(); }, { threshold: .2 });
        this.observer.observe(this);
        const preload = () => { this.preloadTimer = setTimeout(() => this.slides.slice(1).forEach(slide => { const image = slide.querySelector('img'); if (image) image.loading = 'eager'; }), 200); };
        const firstImage = this.slides[0].querySelector('img');
        if (!firstImage || firstImage.complete) preload();
        else listen(firstImage, 'load', preload, { once: true });
        this.sync();
      }
      show(index, manual = false) {
        if (manual) this.paused = true;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
        this.dots.forEach((dot, i) => { if (i === this.index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
        this.sync();
        this.status.textContent = this.slides[this.index].dataset.slideStatus;
      }
      sync() {
        clearTimeout(this.timer);
        this.rotation.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.querySelector('[data-play-icon]').toggleAttribute('hidden', !this.paused);
        this.querySelector('[data-pause-icon]').toggleAttribute('hidden', this.paused);
        this.status.setAttribute('aria-live', this.paused ? 'polite' : 'off');
        if (!this.paused && !this.hovered && !this.touching && this.inView && !document.hidden && !this.motion.matches) this.timer = setTimeout(() => this.show(this.index + 1), this.interval);
      }
      disconnectedCallback() { clearTimeout(this.timer); clearTimeout(this.preloadTimer); this.abort?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orela-home-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('orela-review-carousel')) {
    customElements.define('orela-review-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('.orela-home-reviews__track');
        this.cards = [...this.querySelectorAll('.orela-home-review')];
        this.dots = [...this.querySelectorAll('[data-slide]')];
        if (!this.track || !this.cards.length) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.active = this.track.clientWidth >= 1000 ? Math.min(2, this.cards.length - 1) : 0;
        this.querySelectorAll('[data-controls]').forEach(el => { el.hidden = false; });
        this.addEventListener('click', event => {
          const direction = event.target.closest('[data-direction]');
          const dot = event.target.closest('[data-slide]');
          if (direction) this.go(this.active + Number(direction.dataset.direction));
          if (dot) this.go(Number(dot.dataset.slide));
        }, {signal});
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          this.go(event.key === 'Home' ? 0 : event.key === 'End' ? this.cards.length - 1 : this.active + (event.key === 'ArrowLeft' ? -1 : 1));
        }, {signal});
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
          clearTimeout(this.settle);
          this.settle = setTimeout(() => this.announce(), 180);
        }, {passive: true, signal});
        this.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(card => card.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.go(index, 'auto');
        }, {signal});
        this.resize = new ResizeObserver(() => this.go(this.active, 'auto'));
        this.resize.observe(this.track);
        this.go(this.active, 'auto');
      }
      go(index, behavior) {
        const count = this.cards.length;
        const next = ((index % count) + count) % count;
        const wrapped = index < 0 || index >= count;
        this.active = next;
        const card = this.cards[next].getBoundingClientRect();
        const track = this.track.getBoundingClientRect();
        this.track.scrollTo({
          left: this.track.scrollLeft + card.left - track.left - (this.track.clientWidth - card.width) / 2,
          behavior: behavior || (this.motion.matches || wrapped ? 'auto' : 'smooth')
        });
        this.setDots(next);
      }
      update() {
        const track = this.track.getBoundingClientRect();
        const center = track.left + track.width / 2;
        let closest = 0;
        let distance = Infinity;
        this.cards.forEach((card, index) => {
          const rect = card.getBoundingClientRect();
          const delta = Math.abs(rect.left + rect.width / 2 - center);
          if (delta < distance) { closest = index; distance = delta; }
        });
        this.active = closest;
        this.setDots(closest);
      }
      setDots(index) {
        this.dots.forEach((dot, number) => {
          if (number === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
      announce() {
        const position = this.querySelector('[data-position]');
        if (position) position.textContent = (this.active + 1) + ' ' + this.dataset.of + ' ' + this.cards.length;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame);
        clearTimeout(this.settle);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orela-product-family-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('orela-family-quick-add')) {
    customElements.define('orela-family-quick-add', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.button = this.querySelector('button[type="submit"]');
        this.error = this.querySelector('[role="alert"]');
        if (!this.form || !this.button) return;
        if (document.querySelector('cart-drawer')) this.button.setAttribute('aria-haspopup', 'dialog');
        this.form.addEventListener('submit', (event) => this.add(event));
      }
      async add(event) {
        event.preventDefault();
        if (this.pending || this.button.disabled) return;
        this.pending = true;
        this.error.hidden = true;
        this.button.setAttribute('aria-busy', 'true');
        this.button.setAttribute('aria-disabled', 'true');
        let added = false;
        try {
          const body = new FormData(this.form);
          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const sections = cart?.getSectionsToRender?.().map((section) => section.id) || [];
          if (sections.length) {
            body.set('sections', sections.join(','));
            body.set('sections_url', window.location.pathname);
            cart.setActiveElement?.(this.button);
          }
          const response = await fetch(this.form.action.replace(/\/?$/, '.js'), {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : this.dataset.errorMessage);
          added = true;
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'orela-family-quick-add', productVariantId: body.get('id'), cartData: data });
          }
          if (!cart || !sections.length || sections.some((id) => !data.sections?.[id])) {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } catch (error) {
          if (added) {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          this.error.textContent = error instanceof TypeError ? this.dataset.errorMessage : error.message || this.dataset.errorMessage;
          this.error.hidden = false;
        } finally {
          this.pending = false;
          this.button.removeAttribute('aria-busy');
          this.button.removeAttribute('aria-disabled');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orela-product-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const resetCreatineMobileEntry = () => {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      if (!document.body.classList.contains('template-product-creatine')) return;

      const navigation = window.performance.getEntriesByType('navigation')[0];
      if (navigation?.type === 'back_forward') return;

      if (window.location.hash === '#orela-main-product') {
        window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
      }

      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    };

    const scheduleMobileEntryReset = () => {
      window.requestAnimationFrame(() => window.requestAnimationFrame(resetCreatineMobileEntry));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleMobileEntryReset, { once: true });
    } else {
      scheduleMobileEntryReset();
    }

    window.addEventListener('pageshow', scheduleMobileEntryReset, { once: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
